<script>
import { Menu } from 'ant-design-vue';
const SubMenu = {
  template: `
    <a-sub-menu :key="menuInfo.ASSEMBLY" v-bind="$props" v-on="$listeners">
      <span slot="title">
        <a-icon v-if="menuInfo.MENU_IMAGE" :type="menuInfo.MENU_IMAGE" />
        <span v-if="!menuCollapseFlag">{{ menuInfo.MENU_NAME }}</span>
      </span>
      <template v-for="item in menuInfo.children">
        <a-menu-item v-if="item.isLeaf" :key="item.ASSEMBLY" @click="$goPath(item)">
          <a-icon v-if="item.MENU_IMAGE" :type="item.MENU_IMAGE" />
          <span v-if="!menuCollapseFlag">{{ item.MENU_NAME }}</span>
        </a-menu-item>
        <sub-menu v-else :key="item.key" :menu-info="item" />
      </template>
    </a-sub-menu>
  `,
  name: 'SubMenu',
  // must add isSubMenu: true
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    // Cannot overlap with properties within Menu.SubMenu.props
    menuInfo: { type: Object, default: () => ({}) },
    menuCollapseFlag: { type: Boolean },
  },
  created() {

  }
};
export default SubMenu;
</script>
